import { action, get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import type SessionStore from "cc-frontend/services/session-store"
import { Promise } from "rsvp"

export default class Planbookv5Route extends Route {
  @service declare sessionStore: SessionStore

  @service router

  @service("ember-store") store

  @service finder

  @service session

  @service headData

  model(params) {
    this.headData.robots = "none"

    // We need to move this to the application model hook
    // also, check if there's any queries being fetched
    return new Promise((resolve, reject) => {
      get(this, "store")
        .find("planbook", params.planbook_id)
        .then((planbook) => {
          if (planbook === undefined) {
            return reject({ status: "404", planbookId: params.planbook_id })
          }

          return get(this, "store")
            .find("rotation-calendar", planbook.relationships.rotationCalendar.data.id)
            .then((rotationCalendar) => {
              resolve({ planbook, rotationCalendar })
            })
        })
    })
  }

  @action
  error(error, _transition) {
    if (error.status === "404") {
      console.log(`Planbook was not found with ID "${error.planbookId}"`)
      return this.replaceWith("not-found", "planbook-not-found")
    } else {
      // Let the route above this handle the error.
      return true
    }
  }
}
